module.exports = __webpack_public_path__ + "img/3.9efb96ad.png";